import { render } from "./OapLoader.vue?vue&type=template&id=2a769f22"
import script from "./OapLoader.vue?vue&type=script&lang=js"
export * from "./OapLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__